import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import SecuredCreditImage from '../../../assets/images/secured_credit_popover_image.png';
import VectorBackground from '../../../assets/images/ftu_leaf.png';
import MobileBackground from '../../../assets/images/background_image.png';
import Custom2FA from '../../CustomComponents/Custom2FA';
import Modal from '../../CustomComponents/Modal';
import { GetApiHeadersWithBearer, PostRequest, GetRequest } from '../../../network/NetworkUtils';
import { GENERATE_OTP_SECURED_CREDIT_CARD, STATUS_SUCCESS_CODE, ELIGIBILITY_CHECK_SECURED_CREDIT_CARD } from '../../../network/URLConstants';
import { useDispatch, useSelector } from 'react-redux';
import CustomAlertModel from '../../CustomComponents/CustomAlertModel';
import { LOGIN_SESSION_KEY } from '../../../Redux/reducers';
import Loader from '../../CustomComponents/Loader';
import { retrieveData } from '../../../helpers/utils/Utils';

const SecuredCreditPromoPopover = ({ isOpen, onClose, triggerSource = "first_login" }) => {
  const { t } = useTranslation();
  const modalRef = useRef(null);
  const HighlightMsgStyles = "font-serif-pro modal-title text-[var(--modal-text-highlight)] text-[clamp(22px,4vw,36px)] leading-[clamp(28px,5vw,44px)] font-normal cursor-pointer pointer-events-none";
  const HeaderMsgStyles = "font-serif-pro modal-title text-[var(--modal-text-heading-clr)] text-[clamp(22px,4vw,36px)] leading-[clamp(28px,5vw,44px)] font-normal cursor-pointer pointer-events-none";
  const SubHeaderMsgStyles = "font-hanken-grotesk modal-title text-[var(--modal-text-heading-clr)] text-[clamp(15px,2.2vw,20px)] leading-[clamp(19px,2.8vw,26px)] font-normal cursor-pointer pointer-events-none";
  const [isOTPVerifyModalOpen, setIsOTPVerifyModalOpen] = useState(false);
  const accessTokenToApi = useSelector(state => state.accessToken);
  const cards = useSelector(state => JSON.parse(state.userCards));
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [showModel, setShowModel] = useState(false);
  const [highlightMsg, setHighlightMsg] = useState('')
  const [headerMsg, setheaderMsg] = useState('')
  const [subHeaderMsg, setSubHeaderMsg] = useState('')
  const [btn1Exists, setBtn1Exists] = useState(false)
  const [btn2Exists, setBtn2Exists] = useState(false)
  const [btn1Text, setBtn1Text] = useState(false)
  const [btn2Text, setBtn2Text] = useState('')
  const [modelImage, setModelImage] = useState('')
  const [btn1TypeAcpt, setBtn1TypeAcpt] = useState(false)
  const [footerMsg, setFooterMsg] = useState('');
  const [btn1Focus, setBtn1Focus] = useState(false);
  const [btn2Focus, setBtn2Focus] = useState(false);
  const [subFooter, setSubFooter] = useState('');
  const [isBorderNone, setisBorderNone] = useState(true);
  const [showErrorImg, setshowErrorImg] = useState(false);

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === 'Escape' && isOpen) {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener('keydown', handleKeyDown);
      if (modalRef.current) {
        modalRef.current.focus();
      }
    }

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [isOpen, onClose]);

  const showAlertModal = (showModel, highlightMsg, headerMsg, subHeaderMsg, btn1Exists, btn2Exists, btn1Text, btn2Text, btn1TypeAcpt, modelImage, footerMsg, showErrorImg, isBorderNone, btn1Focus, btn2Focus) => {
    setshowErrorImg(showErrorImg)
    setisBorderNone(isBorderNone)
    setShowModel(showModel)
    setHighlightMsg(highlightMsg)
    setheaderMsg(headerMsg)
    setSubHeaderMsg(subHeaderMsg)
    setBtn1Exists(btn1Exists)
    setBtn2Exists(btn2Exists)
    setBtn1Text(btn1Text)
    setBtn2Text(btn2Text)
    setBtn1TypeAcpt(btn1TypeAcpt)
    setModelImage(modelImage)
    setFooterMsg(footerMsg)
    setBtn1Focus(btn1Focus)
    setBtn2Focus(btn2Focus)
  }
  const generate2FAOtp = async () => {
    const deviceId = await retrieveData('updatedDeviceId');
    const headers = await GetApiHeadersWithBearer(deviceId, accessTokenToApi);
    const requestObject = {
      cardKey: cards !== null ? cards[0].CardKey : 0,
    };
    setLoading(true);
    const url = GENERATE_OTP_SECURED_CREDIT_CARD.replace('{CARD_KEY}', cards !== null ? cards[0].CardKey : 0);
    try {
      const response = await PostRequest(url, requestObject, headers);
      setLoading(false);
      const parsedResponse = JSON.parse(response);
      if (parsedResponse.ResponseCode === STATUS_SUCCESS_CODE) {
        const loginSessionPayLoad = { loggedSessionKey: parsedResponse.Response.sessionId }
        dispatch({ type: LOGIN_SESSION_KEY, payload: loginSessionPayLoad });
        const userIdPayload = { userId: parsedResponse.Response.userId }
        dispatch({ type: 'USER_ID', payload: userIdPayload });
        setTimeout(() => {
          setIsOTPVerifyModalOpen(true);
        }, 1000);
      } else {
        const arrMessages = parsedResponse.Messages;
        const message = arrMessages[0];
        const displayText = message.DisplayText;
        showAlertModal(true, t("oops_exclamation"), '', displayText, true, false, t('home'), t('back_to_card_services'), true, require('../../../../assets/images/warning.png'), '', false, false, true, false)

      }
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  const handleApplyClick = () => {
    generate2FAOtp();
  };

  const eligibilityCheckSecuredCreditCard = async () => {
    const deviceId = await retrieveData('updatedDeviceId');
    const headers = await GetApiHeadersWithBearer(deviceId, accessTokenToApi);
    setLoading(true);
    const url = ELIGIBILITY_CHECK_SECURED_CREDIT_CARD.replace('{CARD_KEY}', cards !== null ? cards[0].CardKey : 0);
    try {
      const response = await GetRequest(url, headers);
      setLoading(false);
      const parsedResponse = JSON.parse(response);
      if (parsedResponse.ResponseCode == STATUS_SUCCESS_CODE) {
        if (parsedResponse.Response.canCreateNew) {
          onClose();
          navigate('/secureCredit/termsandcondition');
        } else {
          navigate("/secureCredit/DepositFunds");
          //this.props.navigation.navigate('AddMoneyAccountSelection', { selectedItem: this.state.cardsList[0], type: translate('secured_credit_card'), balanceRequiredForSecuredCredit: parsedResponse.Response.requiredBalanceToAdd })
        }

      } else {
        const arrMessages = parsedResponse.Messages;
        const message = arrMessages[0];
        const displayText = message.DisplayText;
        showAlertModal(true, t("oops_exclamation"), '', displayText, true, false, t('home'), t('back_to_card_services'), true, require('../../../../assets/images/warning.png'), '', false, false, true, false)
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    }

  }

  const closeOTPVerifyModal = () => { setIsOTPVerifyModalOpen(false) }

  const handleMaybeLaterClick = () => {
    onClose();
  };

  const closeModel = () => {
    setShowModel(false);
  }

  const onAcptBtnClick = () => {
    navigate('/home')
  }
  const onCancelBtnClick = () => {
    setShowModel(false)
  }
  if (!isOpen) return null;

  return (
    <div>
      <div className="sm:hidden fixed inset-0 bg-[var(--modalcard-overlay)]" style={{ zIndex: 100 }}>
        <div className="w-full min-h-full bg-[#324261] flex flex-col justify-center items-center">
          <div
            style={{
              width: '360px',
              height: '749.53px',
              paddingTop: '100px',
              paddingRight: '60px',
              paddingBottom: '64px',
              paddingLeft: '60px',
              gap: '32px',
              transform: 'rotate(0deg)',
              opacity: 1,
              display: 'flex',
              flexDirection: 'column',
              position: 'relative',
              backgroundImage: `url(${MobileBackground})`,
              backgroundSize: '80%',
              backgroundPosition: 'center 20%',
              backgroundRepeat: 'no-repeat'
            }}
          >
          <div
            ref={modalRef}
            className="focus:outline-none flex flex-col"
            tabIndex="-1"
            role="dialog"
            aria-modal="true"
            aria-labelledby="secured-credit-title-mobile"
            aria-describedby="secured-credit-description-mobile"
            style={{ flex: 1 }}
          >
            <div className="relative z-10 flex items-start justify-between p-2 pt-1 flex-shrink-0">
              <div className="flex-1 pr-4" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginLeft: '35px' }}>
                <h1
                  id="secured-credit-title-mobile"
                  className="font-serif-pro text-white mb-2 font-normal"
                  style={{
                    fontFamily: 'Source Serif Pro',
                    fontWeight: 400,
                    fontStyle: 'normal',
                    fontSize: '26px',
                    lineHeight: '32px',
                    letterSpacing: '-0.8%',
                    width: '248px',
                    height: '96px',
                    transform: 'rotate(0deg)',
                    opacity: 1,
                    textAlign: 'left',
                    display: 'inline-block',
                    marginLeft: '-30px'
                  }}
                >
                  {(() => {
                    const titleText = t('SECURED_CREDIT_MAIN_TITLE');
                    let mobileText = titleText.replace(/\n/g, ' ');
                    mobileText = mobileText.replace('credit with', 'credit with\n');
                    mobileText = mobileText.replace('Secured Credit', 'Secured\nCredit');
                    
                    return mobileText.split('\n').map((line, index) => (
                      <React.Fragment key={index}>
                        {index === 0 ? (
                          <span style={{ color: '#A3CEBB' }}>{line}</span>
                        ) : (
                          <span style={{ color: 'white' }}>{line}</span>
                        )}
                        {index < mobileText.split('\n').length - 1 && <br />}
                      </React.Fragment>
                    ));
                  })()}
                </h1>
                <p className="font-hanken-grotesk text-white opacity-90"
                   style={{ 
                     textAlign: 'left',
                     fontFamily: 'Hanken Grotesk',
                     fontWeight: 400,
                     fontStyle: 'normal',
                     fontSize: '16px',
                     lineHeight: '24px',
                     letterSpacing: '0%',
                     width: '248px',
                     height: '35px',
                     transform: 'rotate(0deg)',
                     opacity: 1,
                     marginLeft: '-30px'
                   }}>
                  {t('SECURED_CREDIT_MAIN_SUBTITLE').replace(/\n/g, ' ').replace('fees, no', 'fees, no\n').split('\n').map((line, index) => (
                    <React.Fragment key={index}>
                      {line}
                      {index < t('SECURED_CREDIT_MAIN_SUBTITLE').replace(/\n/g, ' ').replace('fees, no', 'fees, no\n').split('\n').length - 1 && <br />}
                    </React.Fragment>
                  ))}
                </p>
              </div>
              <button
                onClick={onClose}
                className="p-2 hover:bg-white hover:bg-opacity-10 rounded-full transition-colors duration-200 flex-shrink-0"
                style={{ 
                  position: 'absolute',
                  top: 'clamp(-110px, -14vw, -70px)',
                  right: 'clamp(-80px, -12vw, -40px)',
                  zIndex: 20,
                  width: '48px',
                  height: '48px',
                  transform: 'rotate(0deg)',
                  opacity: 0.4
                }}
                aria-label="Close"
              >
                <svg className="w-6 h-6" fill="none" stroke="#9CA3AF" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>

            <div className="flex-shrink-0">
              
              <div className="flex flex-col items-center px-4 pt-6 pb-6 gap-6">

                <img
                  src={SecuredCreditImage}
                  className="h-auto object-contain mx-auto"
                  alt=""
                  style={{
                    width: '217.86px',
                    height: '172.53px',
                    transform: 'rotate(0deg)',
                    opacity: 1
                  }}
                />

                <p 
                  className="text-white"
                  style={{
                    fontFamily: 'Hanken Grotesk',
                    fontWeight: 400,
                    fontStyle: 'normal',
                    fontSize: '11px',
                    lineHeight: '17px',
                    letterSpacing: '0%',
                    width: '240px',
                    height: '34px',
                    transform: 'rotate(0deg)',
                    opacity: 1,
                    textAlign: 'left',
                    paddingTop: '25px'
                  }}
                >
                  {(() => {
                    const text = t('SECURED_CREDIT_REQUIREMENT_TEXT').replace(/\n/g, ' ');
                    return text.replace('spending account', 'spending\naccount').split('\n').map((line, index) => (
                      <span key={index}>
                        {line}
                        {index === 0 && <br />}
                      </span>
                    ));
                  })()}
                </p>

                <button
                  onClick={handleApplyClick}
                  className="font-hanken-grotesk w-full font-bold border-0 
                           bg-[#2965FB] hover:bg-blue-600 text-white
                           focus:outline-none flex items-center justify-center"
                  style={{
                    width: '240px',
                    height: '56px',
                    paddingTop: '16px',
                    paddingRight: '93px',
                    paddingBottom: '16px',
                    paddingLeft: '93px',
                    transform: 'rotate(0deg)',
                    opacity: 1,
                    fontFamily: 'Hanken Grotesk',
                    fontWeight: 700,
                    fontStyle: 'normal',
                    lineHeight: '16px',
                    letterSpacing: '0%',
                    textAlign: 'center',
                    verticalAlign: 'middle',
                    marginTop: '20px',
                    whiteSpace: 'nowrap'
                  }}
                  autoFocus
                >
                  <span
                    style={{
                      width: '79px',
                      height: '16px',
                      transform: 'rotate(0deg)',
                      opacity: 1,
                      display: 'inline-block'
                    }}
                  >
                    {t('SECURED_CREDIT_APPLY_NOW')}
                  </span>
                </button>

                <button
                  onClick={handleMaybeLaterClick}
                  className="font-hanken-grotesk modal-title font-medium bg-transparent border-none 
                           cursor-pointer text-[#94C3E8] hover:opacity-90 focus:outline-none"
                  style={{
                    width: '240px',
                    height: '56px',
                    paddingTop: '16px',
                    paddingRight: '93px',
                    paddingBottom: '16px',
                    paddingLeft: '93px',
                    transform: 'rotate(0deg)',
                    opacity: 1,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    position: 'relative',
                    marginTop: '-10px'
                  }}
                >
                  <span
                    style={{
                      fontFamily: 'Hanken Grotesk',
                      fontWeight: 700,
                      fontStyle: 'normal',
                      fontSize: 'clamp(14px, 3.5vw, 16px)',
                      lineHeight: 'clamp(14px, 3.5vw, 16px)',
                      letterSpacing: '0%',
                      textAlign: 'center',
                      position: 'absolute',
                      left: '50%',
                      top: '50%',
                      transform: 'translate(-50%, -50%)',
                      whiteSpace: 'nowrap'
                    }}
                  >
                    {t('SECURED_CREDIT_NO_THANKS')}
                  </span>
                </button>

              </div>
            </div>
          </div>
          </div>
        </div>
      </div>

      <div className="hidden sm:flex fixed inset-0 items-center justify-center bg-[var(--modalcard-overlay)]" style={{ zIndex: 100 }}>
        <div
          ref={modalRef}
          className="relative focus:outline-none z-50 bg-[#324261] border-[2.22px] border-transparent 
                     w-[90vw] max-w-[400px] h-[80vh] max-h-[600px] gap-[2px] rotate-0 opacity-100 
                     pt-[50px] pb-[70px] 
                     sm:w-[85vw] sm:max-w-[500px] sm:h-[85vh] sm:max-h-[700px] sm:pt-[55px] sm:pb-[90px]
                     md:w-[80vw] md:max-w-[600px] md:h-[90vh] md:max-h-[800px] md:pt-[60px] md:pb-[100px]
                     lg:w-[75vw] lg:max-w-[700px] lg:h-[92vh] lg:max-h-[900px] lg:pt-[65px] lg:pb-[115px]
                     xl:w-[778px] xl:h-[998px] xl:pt-[60px] xl:pb-[120px]
                     overflow-hidden rounded-tr-[36px] rounded-bl-[36px]
                     sm:rounded-tr-[45px] sm:rounded-bl-[45px]
                     md:rounded-tr-[54px] md:rounded-bl-[54px]
                     lg:rounded-tr-[63px] lg:rounded-bl-[63px]
                     xl:rounded-tr-[72px] xl:rounded-bl-[72px]"
          tabIndex="-1"
          role="dialog"
          aria-modal="true"
          aria-labelledby="secured-credit-title-desktop"
          aria-describedby="secured-credit-description-desktop"
        >
          <div
            style={{
              position: 'absolute',
              inset: 0,
              backgroundImage: `url(${VectorBackground})`,
              backgroundSize: '679px 530px',
              backgroundPosition: 'right 100px top 50px',
              backgroundRepeat: 'no-repeat',
              borderTopRightRadius: '36px',
              borderBottomLeftRadius: '36px',
              pointerEvents: 'none',
              transform: 'rotate(0deg)',
              opacity: 1,
              border: '2.22px solid transparent'
            }}
          />

          <div
            className="relative z-10 flex flex-col"
          >
            <div className="flex items-start justify-between mb-4 sm:mb-6 md:mb-6 lg:mb-8 xl:mb-10 px-4 sm:px-6 md:px-8 lg:px-12 xl:px-16">
              <div className="flex-1 pr-3 sm:pr-4 md:pr-6 max-w-full">
                <h1
                  id="secured-credit-title-desktop"
                  className="font-serif-pro modal-title text-white mb-2 sm:mb-3 md:mb-4 lg:mb-4 xl:mb-5 font-normal"
                  style={{
                    fontFamily: 'Source Serif Pro',
                    fontWeight: 400,
                    fontStyle: 'normal',
                    fontSize: '32px',
                    lineHeight: '38px',
                    letterSpacing: '0%',
                    width: '458px',
                    height: '76px',
                    transform: 'rotate(0deg)',
                    opacity: 1,
                    textAlign: 'left',
                    display: 'inline-block',
                    marginLeft: '60px'
                  }}
                >
                  {t('SECURED_CREDIT_MAIN_TITLE').split('\n').map((line, index) => (
                    <React.Fragment key={index}>
                      {index === 0 ? (
                        <>
                          <span style={{ color: '#A3CEBB' }}>{line.split(' with a Kudzu')[0]}</span>
                          <span style={{ color: 'white' }}>{line.includes(' with a Kudzu') ? ' with a Kudzu' : line.substring(line.split(' with a Kudzu')[0].length)}</span>
                        </>
                      ) : (
                        line
                      )}
                      {index < t('SECURED_CREDIT_MAIN_TITLE').split('\n').length - 1 && <br />}
                    </React.Fragment>
                  ))}
                </h1>

                <p
                  className="font-hanken-grotesk modal-title text-white opacity-90 mb-6 sm:mb-6 md:mb-8 lg:mb-8 xl:mb-10"
                  style={{ 
                    fontFamily: 'Hanken Grotesk',
                    fontWeight: 500,
                    fontStyle: 'normal',
                    fontSize: '20px',
                    lineHeight: '30px',
                    letterSpacing: '0%',
                    width: '458px',
                    height: '30px',
                    transform: 'rotate(0deg)',
                    opacity: 1,
                    marginLeft: '60px'
                  }}
                >
                  {t('SECURED_CREDIT_MAIN_SUBTITLE')}
                </p>
              </div>

              <button
                onClick={onClose}
                className="p-2 hover:bg-white hover:bg-opacity-10 rounded-full transition-colors duration-200 flex-shrink-0"
                style={{
                  width: '48px',
                  height: '48px',
                  transform: 'rotate(0deg)',
                  opacity: 0.4,
                  marginTop: '-20px'
                }}
                aria-label="Close"
              >
                <svg
                  className="w-5 h-5"
                  fill="none"
                  stroke="#9CA3AF"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </button>
            </div>

            <div className="flex-shrink-0">
              <div
                id="secured-credit-description-desktop"
                className="px-4 sm:px-6 md:px-8 lg:px-12 xl:px-16"
              >
              <div className="flex justify-center mb-4 sm:mb-6 md:mb-6 lg:mb-8 xl:mb-10 -mt-2">
                <div 
                  className="opacity-100"
                  style={{
                    width: 'clamp(180px, 25vw, 400px)',
                    height: 'auto',
                    maxHeight: 'clamp(200px, 25vh, 350px)'
                  }}
                >
                  <img
                    src={SecuredCreditImage}
                    alt=""
                    className="object-contain"
                    style={{
                      width: '399px',
                      height: '316px',
                      objectFit: 'contain',
                      transform: 'rotate(0deg)',
                      opacity: 1
                    }}
                  />
                </div>
              </div>

              <div className="text-left ml-2 sm:ml-6 md:ml-8 lg:ml-12 xl:ml-16 mt-6 sm:mt-8 md:mt-10 lg:mt-12 xl:mt-16">
                <p className="font-hanken-grotesk modal-title text-white opacity-90 mb-2 sm:mb-3 md:mb-4 lg:mb-4 xl:mb-4"
                   style={{
                     fontFamily: 'Hanken Grotesk',
                     fontWeight: 400,
                     fontStyle: 'normal',
                     fontSize: '16px',
                     lineHeight: '100%',
                     letterSpacing: '0%',
                     width: '458px',
                     height: '42px',
                     transform: 'rotate(0deg)',
                     opacity: 1,
                     paddingTop: '40px'
                   }}>
                  {t('SECURED_CREDIT_REQUIREMENT_TEXT').split('\n').map((line, index) => (
                    <React.Fragment key={index}>
                      {line}
                      {index < t('SECURED_CREDIT_REQUIREMENT_TEXT').split('\n').length - 1 && <br />}
                    </React.Fragment>
                  ))}
                </p>
              </div>
            </div>
            </div>

            <div className="px-4 sm:px-6 md:px-8 lg:px-12 xl:px-16 pt-4 sm:pt-6 md:pt-6 lg:pt-8 xl:pt-10">
              <div className="text-left ml-2 sm:ml-6 md:ml-8 lg:ml-12 xl:ml-16">
                
                <div className="pb-3 sm:pb-4">
                  <button
                    onClick={handleApplyClick}
                    className="font-hanken-grotesk font-bold border-0 
                             bg-[#2965FB] hover:bg-blue-600 text-white
                             focus:outline-none flex items-center justify-center"
                    style={{
                      width: '458px',
                      height: '60px',
                      paddingTop: '16px',
                      paddingRight: '93px',
                      paddingBottom: '16px',
                      paddingLeft: '93px',
                      transform: 'rotate(0deg)',
                      opacity: 1,
                      fontFamily: 'Hanken Grotesk',
                      fontWeight: 700,
                      fontStyle: 'normal',
                      lineHeight: '16px',
                      letterSpacing: '0%',
                      textAlign: 'center',
                      verticalAlign: 'middle'
                    }}
                    autoFocus
                  >
                    <span
                      style={{
                        width: '79px',
                        height: '16px',
                        transform: 'rotate(0deg)',
                        opacity: 1,
                        display: 'inline-block'
                      }}
                    >
                      {t('SECURED_CREDIT_APPLY_NOW')}
                    </span>
                  </button>
                </div>

                <div className="flex justify-center">
                  <button
                    onClick={handleMaybeLaterClick}
                    className="font-hanken-grotesk modal-title font-medium bg-transparent border-none 
                             cursor-pointer text-[#94C3E8] hover:opacity-90 focus:outline-none"
                    style={{
                      width: 'clamp(300px, 85vw, 458px)',
                      height: 'clamp(50px, 12vw, 60px)',
                      padding: 'clamp(12px, 3vw, 16px) clamp(60px, 15vw, 93px)',
                      transform: 'rotate(0deg)',
                      opacity: 1,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      position: 'relative'
                    }}
                  >
                    <span
                      style={{
                        fontFamily: 'Hanken Grotesk',
                        fontWeight: 700,
                        fontStyle: 'normal',
                        fontSize: 'clamp(14px, 3.5vw, 16px)',
                        lineHeight: 'clamp(14px, 3.5vw, 16px)',
                        letterSpacing: '0%',
                        textAlign: 'center',
                        position: 'absolute',
                        left: 'clamp(44%, 6vw, 50%)',
                        top: '50%',
                        transform: 'translate(-50%, -50%)',
                        whiteSpace: 'nowrap'
                      }}
                    >
                      {t('SECURED_CREDIT_NO_THANKS')}
                    </span>
                  </button>
                </div>

 
                </div>
            </div>
        </div>
      </div>
      </div>

      <Modal
        isOpen={isOTPVerifyModalOpen}
        onClose={closeOTPVerifyModal}
        isLogo={false}
        subHeaderMsg={<p className="font-hanken-grotesk modal-title text-[clamp(13px,1.8vw,20px)] leading-[clamp(17px,2.4vw,26px)] font-normal cursor-pointer pointer-events-none">{t("standard_msg_and_data_rates_may_apply")}</p>}
        title={<p className={HighlightMsgStyles}> {t("security_check_custom2fa")}</p>}
        subtitle={<p className={HeaderMsgStyles}>{t("we_are_sending_text")}</p>}
        content={<div className="mt-10"><Custom2FA type={t("secured_credit_card")} onClose={closeOTPVerifyModal} verificationSuccess={eligibilityCheckSecuredCreditCard} verificationFailure={() => { }} /></div>}
      />
      {showModel &&
        <CustomAlertModel
          isOpen={showModel}
          onClose={closeModel}
          image={modelImage}
          highlightMsg={<p className={`${HighlightMsgStyles} sm:flex block flex-col`}>{highlightMsg}
            <span className={HeaderMsgStyles}> {headerMsg}</span></p>}
          subHeaderMsg={<p className={SubHeaderMsgStyles}>{subHeaderMsg}</p>}
          btn1Exists={btn1Exists}
          btn2Exists={btn2Exists}
          btn1Text={btn1Text} btn2Text={btn2Text}
          btn1TypeAcpt={btn1TypeAcpt}
          verificationFailure={() => { }}
          footerMsg={<p className={SubHeaderMsgStyles}>{footerMsg}</p>}
          onAcptBtnClick={onAcptBtnClick}
          subFooter={<p className={SubHeaderMsgStyles}>{subFooter}</p>}
          onCancelBtnClick={onCancelBtnClick}
          showErrorImg={showErrorImg}
          isBorderNone={isBorderNone}
          btn1Focus={btn1Focus}
          btn2Focus={btn2Focus}
        />
      }
      {loading && <Loader />}
    </div>
  );
};

export default SecuredCreditPromoPopover;